import React from "react";
import "./style.css";
import Card from "react-bootstrap/Card";
import "bootstrap/dist/css/bootstrap.min.css";

export const BillingEstimation = ({ data }) => {
    return (
        <Card style={{borderRadius:"0px"}}>
            <Card.Header>
                <Card.Title>Estimation</Card.Title>
            </Card.Header>
            <Card.Body>
                <Card.Title>Total cost: {data?.totalCost}</Card.Title>

                {!!data?.dailyEstimation ? (
                    data?.dailyEstimation.map((o, index) => (
                        <Card>
                            <Card.Header>
                                <span>Timestamp: {o?.timestamp}</span>
                                <span className="padding-left-20px">
                                    Daily cost: {o?.dailyCost}
                                </span>
                            </Card.Header>
                            <Card.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">App</th>
                                            <th scope="col">Method</th>
                                            <th scope="col">Count</th>
                                            <th scope="col">Cost</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {o?.billing.map((b, bIndex) =>
                                            b?.estimation.map((e, eIndex) => (
                                                <tr>
                                                    <td>{b?.app}</td>
                                                    <td>{e?.method}</td>
                                                    <td>{e?.count}</td>
                                                    <td>{e?.cost}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    ))
                ) : (
                    <div>No billing data found</div>
                )}
            </Card.Body>
        </Card>
    );
};
